import DropinSupervisorBase from "../dropin-supervisor-base";
import TimingInfo from "../timing-info";
import { getVersionString, stampVersion, doPassThrough } from "../utils";

/**
 * @category Render Spaces
 * @description
 * Render spaces are the place where the actual rendering happens.
 * They are responsible for managing 1 or more dom elements in service of a particular
 * rendering library. Mutiple Render Spaces can use the same rendering library
 * for stacking purposes.
 */
export class DIBRenderSpace {
  // flag for easily disabling
  protected isActive: boolean = true;

  protected normX: number = 0;
  protected normY: number = 0;
  protected normWidth: number = 0;
  protected normHeight: number = 0;
  protected supervisor: DropinSupervisorBase = null;
  protected parent: DIBRenderSpace;

  constructor() {}

  // stamp our version to the window for future debugging
  public stampVersion() {
    stampVersion(this.constructor.name, getVersionString(this, DIBRenderSpace));
  }

  public setSupervisor(supervisor: DropinSupervisorBase) {
    this.supervisor = supervisor;
  }

  public getWidth(): number {
    return 0;
  }

  public getHeight(): number {
    return 0;
  }

  public getTop(): number {
    return 0;
  }

  public getBottom(): number {
    return 0;
  }

  public setBounds(x: number, y: number, width: number, height: number): void {
    this.normX = x;
    this.normY = y;
    this.normWidth = width;
    this.normHeight = height;
  }

  // if this is not set, default to the window
  public setRenderspaceParent(parent: DIBRenderSpace) {
    this.parent = parent;
  }

  public onWindowResize(): void {}

  onRequestAnimFrame(timingInfo: TimingInfo) {}

  // this is where initialization should go
  onFrameZero() {
    this.onWindowResize();
  }

  // this is a passthrough for adding event listeners
  addEventListener(eventName: string, callback: (e: Event) => void): void {
    this.getEventTarget().addEventListener(eventName, callback);
  }

  // this is a passthrough for adding event listeners
  dispatchEvent(event: Event): void {
    this.getEventTarget().dispatchEvent(event);
  }

  // this will do different things depending
  // on the type of renderspace
  // most of the time its just going to return the canvas though
  getEventTarget(): HTMLElement {
    return null;
  }

  passEventsTo(eventTarget: DIBRenderSpace | HTMLElement) {
    if (eventTarget instanceof DIBRenderSpace) {
      eventTarget = eventTarget.getEventTarget();
    }

    doPassThrough(this.getEventTarget(), eventTarget);
  }

  public static readonly NameTag: string = "";
}

DIBRenderSpace["Version"] = "1.0.0";

export default DIBRenderSpace;
